/**
 * The short date the copy rule asks for ("Mon Oct 26"), moved byte-identically out of
 * `pages/Portal/ActionPlan/actionPlan.ts` (which re-exports it) so the matter rows can print
 * it without pulling that file, and its board palette, into the frozen Filings closure.
 */
export const utc = (iso: string): number => {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return Date.UTC(y, (m || 1) - 1, d || 1);
};

/** One Intl.DateTimeFormat per options: toLocaleDateString builds one a call, 118 ms of a 6x CPU pick (O8 F5). */
const FORMATS = new Map<string, Intl.DateTimeFormat>();
export const fmt = (iso: string, opts: Intl.DateTimeFormatOptions): string => {
  const k = JSON.stringify(opts);
  let f = FORMATS.get(k);
  if (!f) {
    f = new Intl.DateTimeFormat("en-US", { ...opts, timeZone: "UTC" });
    FORMATS.set(k, f);
  }
  return f.format(utc(iso));
};

/** Tooltip sentences: "Fri Oct 16", the year only when it is not today's. */
export const formatDay = (iso: string, today: string): string =>
  `${fmt(iso, { weekday: "short" })} ${fmt(iso, { month: "short", day: "numeric" })}${
    iso.slice(0, 4) === today.slice(0, 4) ? "" : `, ${iso.slice(0, 4)}`
  }`;

export const DAY_MS = 86_400_000;

/** Whole days from `fromIso` to `iso`, both server New York dates. */
export const daysBetween = (fromIso: string, iso: string): number =>
  Math.round((utc(iso) - utc(fromIso)) / DAY_MS);

/** Board R6: "Today", "Tue Oct 6" inside 90 days, "Apr 6, 2027" beyond. */
export const formatActBy = (iso: string, today: string): string => {
  if (iso === today) return "Today";
  if (Math.abs(daysBetween(today, iso)) <= 90) return formatDay(iso, iso);
  return fmt(iso, { month: "short", day: "numeric", year: "numeric" });
};

/** A date mid-sentence ("by Fri Jan 8"), "today" on the day; one convention for the bar tips and the rail. */
export const rowDay = (iso: string, today: string) =>
  iso === today ? "today" : formatActBy(iso, today);
